export default "__VITE_ASSET__7KSbT3KP__"